import _assignIn from 'lodash.assignin';
import _cloneDeep from 'lodash.clonedeep';
import _isEmpty from 'lodash.isempty';
import _set from 'lodash/set';

export * from './routes';

export const cloneDeep = _cloneDeep;
export const isEmpty = _isEmpty;
export const assignIn = _assignIn;
export const set = _set;

export const normalizePhone = (value, previousValue) => {
    if (!value) {
        return value;
    }
    const onlyNums = value.replace(/[^\d]/g, '');
    if (!previousValue || value.length > previousValue.length) {
        // typing forward
        if (onlyNums.length === 3) {
            return `${onlyNums}-`;
        }
        if (onlyNums.length === 6) {
            return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}-`;
        }
    }
    if (onlyNums.length <= 3) {
        return onlyNums;
    }
    if (onlyNums.length <= 6) {
        return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
    }
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`;
};

export function isElitePackageEnabled(state, additionalSelectors) {
    const isElitePackageDealer = additionalSelectors.dealerSelectors.isElitePackageDealer(state);
    const isElitePackageDealerATC = additionalSelectors.dealerSelectors.isElitePackageDealerATC(state);
    const sponsor = additionalSelectors.offerSelectors.getOfferSourceSponsor(state);
    const isATCDeal = sponsor?.toLowerCase() === 'atc';
    return (isElitePackageDealer && !isATCDeal) || (isElitePackageDealerATC && isATCDeal);
}
